import styles from './index.css';
import { heroes } from '../../../../../components';
import { renderFeedbackButtons } from './feedbackButtons';
import Settings from '../../../../../helpers/settings';

const contentItem = function ({
  author: {
    externalId,
    name,
    bio,
    photoUrl,
  } = {},
  id,
  summary,
  createdAt,
  createdAtRelative,
  headline,
}) {
  const { locale = 'en', appId } = Settings.getAll();

  const addItemProp = !['zaehlerschrank24-de'].includes(appId);

  const html = `
    <div ${addItemProp ? 'itemprop="review" itemscope="" itemtype="https://schema.org/Review"' : ''}>
      <div class="${styles.expertTeaserContent}" ${addItemProp ? 'itemprop="author" itemscope="" itemtype="https://schema.org/Person"' : ''}>
        ${heroes({ avatars: [photoUrl], width: 60, addItemProp })}
        <div>
          <button class="author-name" value="${appId}/guurus/${externalId}" ${addItemProp ? 'itemprop="name"' : ''}>
            ${name}
          </button>
          <span ${addItemProp ? 'itemprop="description"' : ''}>${bio || ''}</span>
        </div>
      </div>
      <div class="${styles.contentBody}">
        ${headline ? `<div class="${styles.headline}" ${addItemProp ? 'itemprop="name"' : ''}>${headline}</div>` : ''}
        <span ${addItemProp ? 'itemprop="reviewBody"' : ''}>"${summary}"</span>
        <div class="${styles.contentFooter}">
          <p ${addItemProp ? 'itemprop="datePublished"' : ''} content="${createdAt.split('T')[0]}">${createdAtRelative}</p>
          ${renderFeedbackButtons({ locale, id })}
        </div>
      </div>
    </div>
  `;
  const wrapper = document.createElement('div');
  wrapper.innerHTML = html;
  return wrapper;
};

export default contentItem;
